import { BaseCheckpointModel } from '../BaseCheckpointModel';
export class EmploymentCheckpoint extends BaseCheckpointModel {
    constructor(checkpoint) {
        super(checkpoint);
        Object.assign(this, checkpoint);
        this.employments.map((employments, index) => {
            employments.id = `${index}_${new Date().getTime()}`;
        });
    }
}
export default EmploymentCheckpoint;
